import { render, staticRenderFns } from "./deducList-all.vue?vue&type=template&id=18e8b5ad&scoped=true"
import script from "./deducList-all.vue?vue&type=script&lang=js"
export * from "./deducList-all.vue?vue&type=script&lang=js"
import style0 from "./deducList-all.vue?vue&type=style&index=0&id=18e8b5ad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e8b5ad",
  null
  
)

export default component.exports